import { render, staticRenderFns } from "./PurchaseTemplate.vue?vue&type=template&id=6a943428&scoped=true&"
import script from "./PurchaseTemplate.vue?vue&type=script&lang=js&"
export * from "./PurchaseTemplate.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseTemplate.vue?vue&type=style&index=0&id=6a943428&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a943428",
  null
  
)

export default component.exports